unit f_volontaridonpotieri;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery, w_table,
  w_edit, w_label, DB, un_user;

type

  TVisibilita = (visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso);
const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo gli ultimi 300 prodotti' ;
  msgDateErrate = 'Correggi le date corrette per visualizzare gli prodotti';
  msgNessunRecord = 'Nessun record da visualizzare';
  msgCaricamentoInCorso = 'Caricamento record in corso...';

type
  { TFrmVolontariDonPotieri }

  TFrmVolontariDonPotieri = class(TWidget)
    procedure AfterRender; override;
  private
    whereDate :String;
    procedure ShowVolontari; async;
    procedure QryVolontariOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita:TVisibilita);
    procedure CalcolaNumeroVolontari;  async;
  published
    procedure tab1_rowclick; async;
    procedure filtro_change;
    procedure filtro_input;
    procedure fltutti_click; async;
    procedure lblHeader_click; async;
    procedure aprimaps; async;
    filtro: TWEdit;
    pnltab1: TJSHTMLElement;
    idautisti : TJSHTMLInputElement;
    idaccompagnatori : TJSHTMLInputElement;
    fltutti : TJSHTMLInputElement;
    QryVolontari: TQuery;
    QryCalcola: TQuery;
    tab1:TWTable;
    labelTop:TWLabel;
    labelBottom:TWLabel;
    pnlTabella:TJSHTMLElement;
  end;

implementation

{$R *.html}

{ TFrmVolontariDonPotieri }

procedure TFrmVolontariDonPotieri.AfterRender;
begin

  QryVolontari.OnFilterRecord := @QryVolontariOnFilterRecord;

  filtro.placeholder := 'Ricerca volontari...';
  filtro.seleziona1.Visible:= false;

  labelTop.header.innerHTML:= '<br><br>';
  labelTop.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 18px; font-weight: bold; border-style: solid;';
  labelTop.footer.innerHTML:= '<br><br>';

  labelBottom.labelbody.innerHTML:= 'bottom';
  labelBottom.header.innerHTML:= '<br>';
  labelBottom.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 22px; font-weight: bold; border-style: solid;';

  fltutti.checked:=false;

  ShowVolontari;

  CalcolaNumeroVolontari;

end;

procedure TFrmVolontariDonPotieri.ShowVolontari; async;
begin

  ImpostaVisibilita(visCaricamentoInCorso);

  QryVolontari.Close;
  QryVolontari.SQL.Text:= ' select dsragionesociale as utente, dstelefono as telefono, ';
  QryVolontari.SQL.Text := QryVolontari.SQL.Text +
    ' TRIM(dsindirizzo) || '', '' || TRIM(dslocalita) || '', '' || TRIM(dsprovincia) AS ind, ';
  QryVolontari.SQL.Text := QryVolontari.SQL.Text + ' (SELECT LIST(c.dscontatto || '': '' || c.dsvalore, '' - '') ';
  QryVolontari.SQL.Text := QryVolontari.SQL.Text + ' FROM an_contatti c ';
  QryVolontari.SQL.Text := QryVolontari.SQL.Text + ' WHERE c.idanagrafica = a.idanagrafica) AS contatti ';
  QryVolontari.SQL.Text := QryVolontari.SQL.Text + ' from an_anagrafiche a ';

  if not fltutti.checked then
    begin
      QryVolontari.SQL.Text := QryVolontari.SQL.Text + ' where dstipo in (''AUAC'',''AC'') ';
  end;
  QryVolontari.SQL.Text := QryVolontari.SQL.Text + ' Order by dsragionesociale ';
  AWait(QryVolontari.Open);

 QryVolontari.FieldByName('ind').Visible:= false;

  RefreshFiltro;

end;

procedure TFrmVolontariDonPotieri.QryVolontariOnFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
var
  str:String;
  i: Integer;
begin
  Accept:= true;
  str := filtro.value.ToLowerInvariant;
  for i:= 0 to DataSet.FieldCount-1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
         exit;
  end;
  //nessun campo matcha la stringa cercata
  Accept := false;
end;

procedure TFrmVolontariDonPotieri.SetLabel(lbl:TWLabel;value:String);
begin

  lbl.Visible :=   value <> '' ;
  lbl.labelbody.innerHTML := value;

end;

procedure TFrmVolontariDonPotieri.ImpostaVisibilita(visibilita: TVisibilita);
begin

  //visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso
  SetLabel(labelTop,'');
  SetLabel(labelBottom,'');

  if visibilita = visDateErrate then SetLabel(labelTop,msgDateErrate);
  if visibilita = visNessunRecord then SetLabel(labelBottom,msgNessunRecord);
  if visibilita = visLimiteRecord then SetLabel(labelBottom,msgLimiteRecord);
  if visibilita = visCaricamentoInCorso then SetLabel(labelBottom,msgCaricamentoInCorso);

  filtro.Visible :=  visibilita <> visDateErrate;
//  console.log(format(' filtro.Visible := %s',[BoolToStr(filtro.Visible,true)]));
  pnltab1.Visible:= visibilita in [visLimiteRecord,visCiSonoRecord];

end;

procedure TFrmVolontariDonPotieri.CalcolaNumeroVolontari;
begin
  // calcolo il numero degli autisti
  QryCalcola.Close;
  QryCalcola.SQL.Text:= ' select count(idanagrafica) as autisti from an_anagrafiche ';
  QryCalcola.SQL.Text := QryCalcola.SQL.Text + ' where dstipo = ''AUAC'' ';
  AWait(QryCalcola.Open);

  idautisti.value := QryCalcola.FieldByName('autisti').AsString;

  // calcolo il numero degli accompagnatori
  QryCalcola.Close;
  QryCalcola.SQL.Text:= ' select count(idanagrafica) as accompagnatori from an_anagrafiche ';
  QryCalcola.SQL.Text := QryCalcola.SQL.Text + ' where dstipo = ''AC'' ';
  AWait(QryCalcola.Open);

  idaccompagnatori.value := QryCalcola.FieldByName('accompagnatori').AsString;

end;

procedure TFrmVolontariDonPotieri.RefreshFiltro;
begin

  QryVolontari.Filtered:= filtro.value.Trim <> '';
  QryVolontari.First;
  tab1.RenderDataSet(QryVolontari);

  if QryVolontari.IsEmpty then
    ImpostaVisibilita(visNessunRecord)
  else if QryVolontari.RecordCount = limiteRecord  then
    ImpostaVisibilita(visLimiteRecord)
  else
    ImpostaVisibilita(visCiSonoRecord);

end;

procedure TFrmVolontariDonPotieri.filtro_change;
begin

  RefreshFiltro;

end;

procedure TFrmVolontariDonPotieri.filtro_input;
begin

  RefreshFiltro;

end;

procedure TFrmVolontariDonPotieri.fltutti_click;
begin
  ShowVolontari;
end;

procedure TFrmVolontariDonPotieri.lblHeader_click;
begin

  ShowVolontari;

end;

procedure TFrmVolontariDonPotieri.aprimaps;
var
  Indirizzo, URL: string;
begin
  Indirizzo := Trim(QryVolontari.FieldByName('ind').AsString);

  if Indirizzo = '' then
    Exit;

  URL := 'https://www.google.com/maps/search/?api=1&query=' +
         EncodeURIComponent(Indirizzo);

  asm
    window.open(URL, '_blank');
  end;
end;

procedure TFrmVolontariDonPotieri.tab1_rowclick;
var
  NumeroTelefono: string;
  Indirizzo: string;
  myself: TFrmVolontariDonPotieri;
  addr: Pointer;
begin
  if not QryVolontari.Active then Exit;
  if QryVolontari.IsEmpty then Exit;

  NumeroTelefono := Trim(QryVolontari.FieldByName('telefono').AsString);
  Indirizzo := Trim(QryVolontari.FieldByName('ind').AsString);

  myself := Self;
  addr := Self.MethodAddress('aprimaps');

  asm
    var vecchio = document.getElementById('popupVolontario');
    if (vecchio) vecchio.remove();

    var popup = document.createElement('div');
    popup.id = 'popupVolontario';

    popup.style.cssText =
      'position:fixed; inset:0; background:rgba(0,0,0,0.65);' +
      'display:flex; align-items:center; justify-content:center;' +
      'z-index:99999; padding:20px;';

    var contenitore = document.createElement('div');

    contenitore.style.cssText =
      'background:white; width:100%; max-width:350px;' +
      'padding:25px; border-radius:16px; text-align:center;' +
      'box-shadow:0 5px 25px rgba(0,0,0,0.3);';

    contenitore.innerHTML =
      '<h2>Cosa vuoi fare?</h2>' +

      '<button id="btnAnnulla" style="width:100%;padding:17px;margin:8px 0;">Annullare</button>' +

      '<button id="btnTelefono" style="width:100%;padding:17px;margin:8px 0;">Telefonare</button>' +

      '<button id="btnMaps" style="width:100%;padding:17px;margin:8px 0;">Vedere la mappa</button>';

    popup.appendChild(contenitore);
    document.body.appendChild(popup);

    document.getElementById('btnAnnulla').onclick = function() {
      popup.remove();
    };

    document.getElementById('btnTelefono').onclick = function() {
      popup.remove();

      if (NumeroTelefono.trim() !== '') {
        window.location.href = 'tel:' + NumeroTelefono;
      } else {
        alert('Numero telefonico non presente.');
      }
    };

    document.getElementById('btnMaps').onclick = function() {

      if (Indirizzo.trim() === '') {
        alert('Indirizzo non presente.');
        return;
      }

      var cb = rtl.createCallback(myself, addr);
      cb();
      popup.remove();
    };
  end;
end;

initialization
  RegisterWeb(TFrmVolontariDonPotieri);

end.

